<template>
  <div id="app">
    <router-view/>
  </div>
</template>

<script>
import cookie from 'vue-cookie'
export default {

  metaInfo() {
    var color_type = cookie.get('color_type') ? cookie.get('color_type') : 1;
    if(color_type=='4'){
      return {
        link:[
          {
            rel:"icon",
            href:"/static/icon/zl_favicon.png"
          },
          {
            rel:'stylesheet',
            href:"/static/css/childmain.css"
          }
        ]
      }
    }else if(color_type=='2'){
      return {
        link:[
         {
            rel:"icon",
            href:"/static/icon/gz_favicon.png"
          },
          {
            rel:'stylesheet',
            href:"/static/css/gzmain.css"
          }
        ]
      }
    }else if(color_type=='3'){
      return {
        link:[
         {
            rel:"icon",
            href:"/static/icon/dmnz_favicon.png"
          },
          {
            rel:'stylesheet',
            href:"/static/css/dmnzmain.css"
          }
        ]
      }
    }else if(color_type=='6'){
      return {
        link:[
          {
            rel:"icon",
            href:"/static/icon/xt_favicon.png"
          },
          {
            rel:'stylesheet',
            href:"/static/css/xtmain.css"
          }
        ]
      }
    }
    return {
      link:[
         {
            rel:"icon",
            href:"/static/icon/cs_favicon.png"
          },
          {
            rel:'stylesheet',
            href:"/static/css/main.css"
          }
      ]
    }
  },
  name: 'App',
  mounted(){
    this.Common.addSPM(this.$route.query.spm);
    this.$Api.get({api:this.Common.getSourec().plapi+'/setting/fragment_setting_list'}).then(response => {
        if(response.data.ResponseStatus == 0){
            var data = response.data.datas;
            this.Common.getSourec().site = data;
        }else{
            this.$dialog.toast({mes: response.data.ResponseMsg});
        }
    });
  }
}
</script>

<style>
/*#app {
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  margin-top: 60px;
}*/
</style>



// WEBPACK FOOTER //
// src/App.vue